import { render } from "./index.vue?vue&type=template&id=965ed7ee&scoped=true&bindings={}"
import script from "./Contact.js?vue&type=script&lang=js"
export * from "./Contact.js?vue&type=script&lang=js"

import "./Contact.scss?vue&type=style&index=0&id=965ed7ee&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-965ed7ee"

export default script